/**
 * MENU CLIC DROIT DE LA SUPERVISION — calculs purs (testés sans navigateur).
 */

/** Prochaine 8 h de Paris : la fin de la nuit d'exploitation. */
const PARIS = new Intl.DateTimeFormat('fr-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })

/** Date et heure de Paris par morceaux : `format` en français écrit « 08 h », illisible pour Number. */
function aParis(d: Date): { ymd: string; heure: number } {
  const parties = PARIS.formatToParts(d)
  const v = (t: string) => parties.find((p) => p.type === t)?.value ?? ''
  return { ymd: `${v('year')}-${v('month')}-${v('day')}`, heure: Number(v('hour')) }
}

export function prochainHuitHeures(maintenant = new Date()): Date {
  const ici = aParis(maintenant)
  const jour = new Date(`${ici.ymd}T12:00:00Z`)
  if (ici.heure >= 8) jour.setUTCDate(jour.getUTCDate() + 1)
  const ymd = jour.toISOString().slice(0, 10)
  for (const decalage of ['+02:00', '+01:00']) {
    const d = new Date(`${ymd}T08:00:00${decalage}`)
    const la = aParis(d)
    if (la.ymd === ymd && la.heure === 8) return d
  }
  return new Date(`${ymd}T08:00:00+01:00`)
}
